import { QueryKey } from '../../constants/index';

export const DIVIDEND_INVALIDATION_KEYS: QueryKey[] = [
  QueryKey.DIVIDEND_PAYOUTS,
  QueryKey.DIVIDEND_PAYOUT,
  QueryKey.DIVIDEND_PAYOUT_ROWS,
  QueryKey.DIVIDEND_STAKEHOLDER_ROWS,
  QueryKey.DIVIDEND_STAKEHOLDER_PAYOUTS,
  QueryKey.DIVIDEND_DISTRIBUTION,
  QueryKey.DIVIDEND_STATS,
];
